import React from 'react'

import checkmark from 'Shared/img/svg/checkmark.svg'

import { StepItemProps } from './props'
import { Container, Title, StepIndicator, CheckmarkIcon } from './styles'

export const StepItem: React.FC<StepItemProps> = ({
  title,
  id,
  isCurrent,
  isPassed,
  onClick,
}) => (
  <Container isCurrent={isCurrent} isPassed={isPassed} onClick={onClick}>
    <StepIndicator isCurrent={isCurrent} isPassed={isPassed}>
      {isPassed ? <CheckmarkIcon src={checkmark} alt="" /> : id}
    </StepIndicator>
    <Title isCurrent={isCurrent} isPassed={isPassed}>
      {title}
    </Title>
  </Container>
)
